module.exports = __webpack_public_path__ + "img/sign-out.4cd8f12e.svg";